import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFLink href="https://goo.gl/maps/5YvRaEgLR9PNyTAN7">
          <CFImage
            src={mobileMap}
            w="100%"
            alt="Sushi Asakusa Japanese Restaurant Map"
          />
        </CFLink>
      </MobileScreen>
      <DefaultScreen>
        <CFLink href="https://goo.gl/maps/5YvRaEgLR9PNyTAN7">
          <CFImage
            src={locationMap}
            w="100%"
            alt="Sushi Asakusa Japanese Restaurant Map"
          />
        </CFLink>
      </DefaultScreen>
    </CFView>
  )
}
